
import '../App.css';
import MainContent from '../components/MainContent';
import { useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, FormWhiteContainer, LabelContainer, LightBlueContainer, LongBlueButton, ShortBlueButton, WhiteContainer } from '../assets/style';
import { Box, IconButton, } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import FormInput from '../components/FormInput';
import { useLocation, useNavigate } from 'react-router';
import TrainingDetailContainer from '../components/Containers/TrainingDetailContainer';
import { userPageName } from '../components/PageName';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useTranslation } from "react-i18next";
import { useApproveRegistrationMutation, useCreateUserMutation, useDeclineRegistrationMutation, useLazyGetRoleDropDownListQuery, useLazyGetUserRegistrationRequestDetailQuery, useUpdateUserMutation } from '../features/auth/authApiSlice';
import { UserDetailModel } from '../models/UserModel';
import HookFormInput from '../components/HookFormInput';
import { Controller, useForm } from 'react-hook-form';
import HookFormDropDownList from '../components/HookFormDropDownList';
import FetchingItems from '../components/FetchingItems';
import { useLazyGetCompanyDropDownListQuery } from '../features/comapny/comapnySlice';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import HookFormSwitch from '../components/HookFormSwitch';
import FormLabel from '../components/FormLabel';
import { dateTimeToTimeStr2, formatDateTime } from '../utils/dateTimeFormmater';
import { AddContractContainer } from '../components/Containers/AddContractContainer';

const AddUserPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const user = getLocation.state?.user as UserDetailModel;
    const userRegistrationRequestId = getLocation.state?.userRegistrationRequestId as number;
    const [isSuccessInitialization, setIsSuccessInitialization] = useState(true)
    const [open, setOpen] = useState(false)

    const [createUser] = useCreateUserMutation()
    const [updateUser] = useUpdateUserMutation()

    const [getUserRegistrationRequestDetail] = useLazyGetUserRegistrationRequestDetailQuery()
    const [approveRegistration] = useApproveRegistrationMutation()
    const [declineRegistration] = useDeclineRegistrationMutation()

    const confirmBoxRef = useRef({ description: "", onConfirm: () => { } })

    const { register, handleSubmit, control, formState: { errors }, reset, getValues, setValue, setError } =
        useForm<UserDetailModel>({
            defaultValues:
                user ?
                    { ...user, appliedAt: "", userRegistrationRequestId: undefined, }
                    : { isActive: true }
        })

    useEffect(() => {
        if (userRegistrationRequestId)
            getUserRegistrationRequestDetail(userRegistrationRequestId).then(res => {
                if ("data" in res) {
                    if (res.data.status != "Pending")
                        navigate("/user-registration-request-detail", { state: { userRegistrationRequest: res.data } })
                    const { id = "", ...others } = { ...(res.data) }
                    reset({ userRegistrationRequestId: id, isActive: true, ...others })
                }
            })
        else {
            if (user) {
                confirmBoxRef.current.onConfirm = handleSubmit(onUpdateSubmit, () => setOpen(false))
                confirmBoxRef.current.description = "Are you sure to update user record?"
            }
            else {
                confirmBoxRef.current.onConfirm = handleSubmit(onCreateSubmit, () => setOpen(false))
                confirmBoxRef.current.description = "Are you sure to create user record?"
            }
        }
    }, [])

    const onClose = function () {
        setOpen(false)
    }

    const openModalConfirmationBox = function () {
        setOpen(true)
    }

    const onApproveBtnClick = () => {
        confirmBoxRef.current.onConfirm = handleSubmit(onApproveSubmit, () => setOpen(false))
        confirmBoxRef.current.description = "Are you sure to approve user registration request?"
        openModalConfirmationBox()
    }

    const onDeclineBtnClick = () => {
        confirmBoxRef.current.onConfirm = handleSubmit(onDeclineSubmit, () => setOpen(false))
        confirmBoxRef.current.description = "Are you sure to decline user registration request?"
        openModalConfirmationBox()
    }

    const handleResponse =
        (message: string, redirect?: () => void) => (
            (res:
                {
                    data: any
                } | {
                    error: FetchBaseQueryError | SerializedError
                }
            ) => {
                setOpen(false)
                if ('error' in res) {
                    if ("data" in res.error && res.error.data) {
                        var errorData = res.error.data as any
                        for (var key in errorData as any) {
                            setError(key as any, {
                                type: "custom", message: errorData[key][0]
                            })
                        }
                    }
                    else
                        alert(`Create Project failed: ${res.error}`)
                }
                else {
                    alert(message)
                    if (redirect)
                        redirect()
                    else
                        navigate('/user-detail', { state: { user: res?.data } })
                }
            }
        )

    const onCreateSubmit = (value: UserDetailModel) => {
        delete value.password2
        createUser(value).then(handleResponse("Create user Successfully"))
    }

    const onUpdateSubmit = (value: UserDetailModel) =>
        updateUser(value).then(handleResponse("Update user Successfully"))

    const onApproveSubmit = (value: UserDetailModel) =>
        approveRegistration(value).then(handleResponse("Approve user registration Successfully"))


    const onDeclineSubmit = (value: UserDetailModel) =>
        declineRegistration(value.userRegistrationRequestId)
            .then(
                handleResponse(
                    "Decline user registration Successfully",
                    () => navigate('/user-registration-request-detail', { state: { userRegistrationRequestId: value.userRegistrationRequestId } })
                )
            )

    const showErrorMessage = (message: string | undefined) =>
        message && <p style={{ color: "red", marginLeft: "28px" }}>{message}</p>

    return (
        <MainContent type={userPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    {!user && <BigHeading>{t("Add New User")}</BigHeading>}
                    {user && <BigHeading>{t("Edit New User")}</BigHeading>}
                    {/* <Controller
                        name='name'
                        control={control}
                        render={(field) =>
                            <HookFormInput title={t("Name")} {...field} />
                        }
                    /> */}
                    <HookFormInput title={t("Name")} register={() => register("name")} />
                    {showErrorMessage(errors.name?.message)}
                    <HookFormInput title={t("Email")} register={() => register("email")} />
                    {showErrorMessage(errors.email?.message)}
                    {!user && !userRegistrationRequestId && <HookFormInput title={t("Password")} type="password" register={() => register("password", { deps: "password2" })} />}
                    {showErrorMessage(errors.password?.message)}
                    {!user && !userRegistrationRequestId &&
                        <HookFormInput
                            title={t("Repeat Password")} type="password"
                            register={() =>
                                register("password2", {
                                    validate: (value) => value !== getValues("password") ? "The password is not same as first input." : undefined,
                                })
                            }
                        />}
                    {showErrorMessage(errors.password2?.message)}
                    <HookFormInput title={t("Phone Number")} register={() => register("phoneNumber")} />
                    {showErrorMessage(errors.phoneNumber?.message)}
                    <HookFormSwitch title={t("Is Active")} name="isActive" control={control} />
                    <FetchingItems<{ id: number, name: string }[]>
                        useLazyQuery={useLazyGetRoleDropDownListQuery}
                        render={(items, isLoading) =>
                            <HookFormDropDownList
                                title={t("Role")}
                                items={isLoading ? [] : items ?? []}
                                control={control}
                                name="roleId"
                            />
                        }
                    />
                    {showErrorMessage(errors.roleId?.message)}
                    {userRegistrationRequestId && <FormLabel title={t("User Declared Company Name")} value={getValues("companyName")} />}
                    <FetchingItems<{ id: string, name: string }[]>
                        useLazyQuery={useLazyGetCompanyDropDownListQuery}
                        render={(items, isLoading) =>
                            <HookFormDropDownList
                                title={t("Company")}
                                items={isLoading ? [] : items ?? []}
                                control={control}
                                name="companyId"
                            />
                        }
                    />
                    {showErrorMessage(errors.companyId?.message)}
                    {userRegistrationRequestId && <FormLabel title={t("Applied at")} value={formatDateTime(getValues("appliedAt"))} />}
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        {
                            !userRegistrationRequestId
                            &&
                            <ShortBlueButton onClick={openModalConfirmationBox} disabled={!isSuccessInitialization}>{t("Save")}</ShortBlueButton>
                        }
                        {
                            userRegistrationRequestId
                            &&
                            <>
                                <ShortBlueButton
                                    onClick={onApproveBtnClick}
                                    disabled={!isSuccessInitialization}
                                >
                                    {t("Approve")}
                                </ShortBlueButton>
                                <ShortBlueButton
                                    onClick={onDeclineBtnClick}
                                    disabled={!isSuccessInitialization}
                                >
                                    {t("Decline")}
                                </ShortBlueButton>
                            </>
                        }
                        <BackButton onClick={() => { navigate('/user', { state: { subpage: userRegistrationRequestId ? "userRegistrationList" : "userList" } }) }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>

            {/* Confirmation Box */}
            <ModalConfirmationBox onConfirm={confirmBoxRef.current.onConfirm} onClose={onClose} open={open} description={confirmBoxRef.current.description} />
        </MainContent>
    )
}

export default AddUserPage;